export const adaptShellProfiles = (shellProfiles, countries, countryKeyName) =>
  shellProfiles.map((shellProfile) => ({
    ...shellProfile,
    countries: countries.filter((country) => shellProfile[countryKeyName].includes(country.value)),
  }));
